import { notify } from 'common-ui-components/components/notification/Notification';
import { Failure, Success } from 'common-ui-components/components/notification/templates';
import API from 'common-ui-components/components/utils/API';
import React, { useContext, useRef, useState } from 'react'
import profileIcon from "./../icons/profile.svg";
import styles from "./ProfileImageEdit.module.css";
import Message from "common-ui-components/components/messager/Message";
import { UserDetailsContext } from 'App';
import { IMAGE_URL, PRODUCT_ID } from "common-ui-components/components/utils/Config";
import Spinner from 'common-ui-components/components/ResponseLoader/Spinner/Spinner';

const ProfileImageEdit=()=>{
    const [loading,setLoading]=useState(false);
    const userDetails = useContext(UserDetailsContext);
    const profileInput = useRef(null);
    const [profileImg, setProfileImg] = useState(null);
    const [modalOpen,setModalOpen]=useState(false);

    const getAndSaveProfileImage = async (e) => {
        const input = e.target;
        const file = input.files[0];
        if (!file) return;

        // Validate file type (allow only image/png, image/jpeg, image/jpg)
        const validTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!validTypes.includes(file.type)) {
            notify(<Failure>Only PNG and JPG images are allowed.</Failure>);
            input.value = ""; // Reset file input
            return;
        }

        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
            setProfileImg(file);
            input.value = "";
        };

        const formDataToSend = new FormData();
        if (file === null)
            formDataToSend.append("profilePicture", new Blob([], {type: "application/octet-stream"}));
        else
            formDataToSend.append("profilePicture", file);

        try
        {
            setLoading(true);
            const response = await API.post("UM/updateProfilePicture", formDataToSend, {
                headers: {"Content-Type": "multipart/form-data"},
            });
            if (response.status.success)
            {
                notify(<Success>Profile photo successfully uploaded</Success>);
                userDetails.setUserDetails((prev) => ({...prev, profilePicture: img.src, photoUpdatedAt: null}));
            }
            else {
                if(response.status?.code === 800) {
                    notify(<Failure>{response.status.message}</Failure>);
                }
                else
                    notify(<Failure>Unable to upload profile picture.</Failure>);
            }
        }
        catch (error) {
            console.error(error);
        }
        finally
        {
            setLoading(false);
        }
    };

    const deletePhoto = async () => {
        try 
        {
            setLoading(true);
            setModalOpen(false);
            const response = await API.post(`/UM/deleteInvitedUserProfilePicture?email=${userDetails.email}`);
            if (response.status) 
            {
                notify(<Success>Profile Image deleted successfully</Success>);
                setProfileImg(null);
                userDetails.setUserDetails((prev) => ({...prev, profilePicture: null, photoUpdatedAt: null}));
            } 
            else 
            {
                notify(<Failure>Failed in deleting Profile Image</Failure>);
            }
        } catch (error) {
            console.error("Error deleting in profile:", error);
            notify(<Failure>Failed in deleting Profile Image</Failure>);
        }
        finally
        {
            setLoading(false)
        }
    };

    const deletePhotoConfirmation=()=>{
        //setModalOpen(true);
        deletePhoto();
    }

    return(
        <div className={styles.profileImageWrapper}>
            {(() => {
                const photoUpdatedAt = userDetails.photoUpdatedAt;
                const photoKey = userDetails.photoKey;
                const locallyChangedImage=userDetails.profilePicture;
                if(locallyChangedImage)
                    return <img src = {locallyChangedImage} alt = "Profile Icon" className = {styles.profileImgEdit} />;
                if (!photoUpdatedAt) 
                    return <img src = {profileIcon} alt = "Profile Icon" className = {styles.profileImgEdit} />;
                return <img className={styles.profileImgEdit} src={`${IMAGE_URL}?type=photo&v=${photoUpdatedAt}&key=${photoKey}&productId=${PRODUCT_ID}`} alt="Photo from database"/>;
            })()}

            <input type="file" ref={profileInput} style={{display: "none"}}
                    accept="image/*" onChange={getAndSaveProfileImage}/>
            {loading ? 
                <div className={styles.overlay}>
                    <Spinner color={"white"} size={"1.5rem"} />
                </div> : 
                <div className={styles.overlay}>
                    <span className={styles.icon} onClick={() => profileInput.current.click()} > 
                        ✎
                    </span>
                    {(userDetails.photoUpdatedAt || userDetails.profilePicture) && (
                        <hr
                            style={{
                                border: "none",
                                borderTop: "1px solid #E9E9E9",
                                width: "55px",
                                margin: "0",
                                transform: "scaleY(0.5)",
                                transformOrigin: "top",
                            }}
                        />
                    )}
                    {(userDetails.photoUpdatedAt || userDetails.profilePicture) && (
                        <span className={styles.icon} onClick={deletePhotoConfirmation} >
                            ✖
                        </span>
                    )}
                </div>
            }
            <Message
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                title="Remove Profile"
                description="Are you sure you want to remove your profile photo?"
                confirmType="Removove"
                onConfirm={deletePhoto}
                onCancel={() => setModalOpen(false)}
            />
        </div>
    )
}

export default ProfileImageEdit